import { DialogRef } from '@angular/cdk/dialog';
import { AsyncPipe } from '@angular/common';
import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { MatCard, MatCardContent } from '@angular/material/card';

import { DmbLabel } from '../../../../model';
import { SessionService } from '../../../../services';
import { FilterComponent } from '../../../form/filter/filter.component';

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  selector: 'dmb-select-label',
  templateUrl: './select-label.component.html',
  styleUrls: ['../../modal.scss', './select-label.component.scss'],
  imports: [MatCard, MatCardContent, AsyncPipe, FilterComponent],
})
export class SelectLabelComponent {
  private sessionService = inject(SessionService);
  private dialogRef = inject(DialogRef);

  labels = toSignal(this.sessionService.labels, { initialValue: [] });
  current = this.sessionService.labelOption;

  select(label: DmbLabel | undefined) {
    if (label) {
      this.sessionService.switchLabel(label);
    } else {
      this.sessionService.unsetLabel();
    }

    this.close();
  }

  close() {
    this.dialogRef.close();
  }
}
